
function ReviewListingDirective() {
	return {
		restrict: 'E',
		scope: {
			reviews: '='
		},
		template: require('./review-listing-template.html'),
		link() {}
	};
}

module.exports = ReviewListingDirective;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/list-review/review-listing-directive.js
 **/